import Vue from 'vue';

// vue-resource
import VueResource from 'vue-resource';

import App from './App.vue';

// använder inte dessa i projektet:
// import router from './router';
// import store from './store';
// import './registerServiceWorker';

// säger till Vue att lägga till saker till core functionality
Vue.use(VueResource);

Vue.config.productionTip = false;



new Vue({
  data: {
    headerindex: 1
  },
  // router,
  // store,
  render: h => h(App)
}).$mount('#app');





// Browsersniffing
// https://codepen.io/gapcode/pen/vEJNZN

// Get IE or Edge browser version
var version = detectIE();

if (version === false) {
  // ej ie eller edge, vill lägga till klassen noieedge på #app
  document.getElementById('app').classList.add('noieedge');

  // document.getElementById('result').innerHTML = '<s>IE/Edge</s>';
} else if (version >= 12) {
  // edge
  // document.getElementById('result').innerHTML = 'Edge ' + version;
} else {
  // ie
  // document.getElementById('result').innerHTML = 'IE ' + version;
}

// add details to debug result
// document.getElementById('details').innerHTML = window.navigator.userAgent;

/**
 * detect IE
 * returns version of IE or false, if browser is not Internet Explorer
 */

function detectIE () {
  var ua = window.navigator.userAgent;

  // Test values; Uncomment to check result …
  // IE 10
  // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';
  // IE 11
  // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';
  // Edge 12 (Spartan)
  // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';
  // Edge 13
  // ua = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586';

  var msie = ua.indexOf('MSIE ');
  if (msie > 0) {
    // IE 10 or older => return version number
    return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
  }

  var trident = ua.indexOf('Trident/');
  if (trident > 0) {
    // IE 11 => return version number
    var rv = ua.indexOf('rv:');
    return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
  }

  var edge = ua.indexOf('Edge/');
  if (edge > 0) {
    // Edge (IE 12+) => return version number
    return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
  }

  // other browser
  return false;
}